import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { select, Store } from '@ngrx/store'
import { isEmpty, omit, pathOr, pick } from 'ramda'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { LanguageConfig } from 'src/app/app.models'
import { GFFP_FIELDS_CATEGORY } from 'src/app/gffp/gffp.models'
import { countriesInfo, CountryDetails, getCountryDetails } from 'src/app/store/countries'
import { DpGetEnums, DpSendCommit, DpSendCommitSuccess, DpSendValidate, DpSendValidateSuccess } from 'src/app/store/digital-payment/digital-payment.action'
import { selectEnumFields } from 'src/app/store/enumeration'
import { FeeQuoteData, isWalletFeeEnabled, selectFeeQuoteState } from 'src/app/store/fee-quote'
import { getCurrentLabelsJson } from 'src/app/store/labels'
import { selectQueryParams } from 'src/app/store/query-params'
import { serviceOptionsState } from 'src/app/store/service-options'
import { stateInfo } from 'src/app/store/states'
import { getSelectedLocationTrns, PaymentMethod, selectPaymentMethod, selectTransactionState, TransactionState } from 'src/app/store/transaction'

@Component({
  selector: 'app-digital-payment',
  templateUrl: './digital-payment.component.html',
  styleUrls: ['./digital-payment.component.scss']
})
export class DigitalPaymentComponent {
  private steps: { [id: string]: number } = {
    digitalPaymentLanding: 0,
    gffp: 1,
    summary: 2,
    confirmation: 3
  }
  
  private _gffpFieldNames: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(undefined!)
  public readonly gffpFieldNames$: Observable<string[]> = this._gffpFieldNames.asObservable()
  
  private _sendValResponseError$: BehaviorSubject<Error[] | null> = new BehaviorSubject<Error[] | null>(null)
  public sendValResponseError$ = this._sendValResponseError$.asObservable()

  private _summaryData$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined)
  public readonly summaryData$: Observable<any> = this._summaryData$.asObservable()

  // public paymentMethod: 'debit' | 'bank' | null = null // Todo: revert #may6
  public paymentMethod: 'debit' | 'bank' | null = 'debit'
  private transactionId: string
  public languageList: LanguageConfig[] = []
  public cmsLabels: any // TODO: Tim: Fix types
  public currentStep: number = 0
  private country: string
  public exchangeRate: number | string

  // Todo: Tim: #may6 - mock payload, will replace once we know what the body will be
  // Todo: Tim: #may6 - create interface for sendValidatePayload type
  private sendValidatePayload: any = {
    "targetAudience": "CONSUMER_FACING",
    "userLanguage": "en-US",
    "destinationCountryCode": "USA",
    "destinationCountrySubdivisionCode": "US-MN",
    "payoutOptionCode": "DIRECT_TO_ACCT",
    "sendAmount": {
      "value": 12,
      "currencyCode": "USD"
    },
    "payoutCurrencyCode": "USDC",
    "sender": {
      "firstName": "John",
      "lastName": "Doe",
      "middleName": "",
      "secondLastName": "",
      "notificationLanguagePreference": "en-US",
      "address": {
        "line1": "1550 Utica Ave S",
        "line2": "",
        "city": "Minneapolis",
        "countrySubdivisionCode": "US-MN",
        "countryCode": "USA",
        "postalCode": "55555"
      },
      "dateOfBirth": "2000-01-01",
      "mobilePhone": {
        "number": "6124447777",
        "countryDialCode": "1"
      }
    },
    "additionalTransactionDetails": {
      "getRelationshipToReceiver": true
    },
    "receiverSameAsSender": true,
    "stagingInfo": {
      "stageTransaction": true,
      "sendLocationAgentPartnerId": "66555706",
      "formFreeCompletion": true
    }
  }

  private endpointVersion: string
  public locale: string
  public operation: string // 'withdraw' | 'deposit' // Todo: Tim: fix types
  public walletProvider: string
  public subdivisionOptions: any[] // Todo: tim: fix types
  private transactionData: TransactionState

  public cmsLabels$: Observable<any> // TODO: Tim: Fix types
  public paymentMethod$: Observable<PaymentMethod | undefined>
  public enumerationsResponse$: Observable<any> | undefined // Todo: tim: fix types
  public isWalletFeeEnabled$: Observable<any> | undefined // Todo: tim: fix types
  public selectedLocation$: Observable<any> | undefined // Todo: tim: fix types
  public countries$: Observable<CountryDetails[]> | undefined
  private subdivisionOptions$: Observable<any> | undefined // Todo: tim: fix types
  private feeQuoteState$: Observable<FeeQuoteData>
  
  private serviceOptionsStateSub: Subscription
  private queryParamsStateSub: Subscription
  private cmsLabelsStateSub: Subscription
  private countryDetailsSub: Subscription
  private dpSendValidateSuccessSub: Subscription
  private dpSendCommitSuccessSub: Subscription
  private stateInfoSub: Subscription
  private selectTransactionStateSub: Subscription
  private feeQuoteStateSub: Subscription

  constructor(
    private store: Store<any>,
    private actions$: Actions,
    private router: Router
  ) {}

  ngOnInit() {
    this.serviceOptionsStateSub = this.store.select(serviceOptionsState).subscribe((serviceOptions) => {
      this.languageList = serviceOptions?.uiConfigs[0]?.languageList || []
      this.transactionId = serviceOptions.transactionId!;
    })

    this.queryParamsStateSub = this.store.select(selectQueryParams).subscribe((queryParams) => {
      console.log('dp queryParams updating...', queryParams) // TOdo: remove: #may6
      this.locale = queryParams.locale
      this.operation = queryParams.operation ?? ''
      this.walletProvider = queryParams.walletProvider ?? ''
      this.endpointVersion = queryParams.endpoint ?? 'v2'
    })
    
    this.countryDetailsSub = this.store.select(getCountryDetails).subscribe((country) => {
      console.log('dp getCountryDetails updating...', country) // TOdo: remove: #may6
      this.country = country.code
    })

    this.paymentMethod$ = this.store.select(selectPaymentMethod)
    this.countries$ = this.store.select(countriesInfo)
    this.isWalletFeeEnabled$ = this.store.select(isWalletFeeEnabled)
    this.selectedLocation$ = this.store.select(getSelectedLocationTrns)
    this.cmsLabels$ = this.store.select(getCurrentLabelsJson)
    this.subdivisionOptions$ = this.store.select(stateInfo)
    this.feeQuoteState$ = this.store.select(selectFeeQuoteState)
    
    this.cmsLabelsStateSub = this.cmsLabels$.subscribe((labels) => {
      if (labels?.labels?.stellar ?? false) {
        this.cmsLabels = labels.labels
      }
      else {
        this.navigateToTransactionFlow()
      }
    })
    
    this.stateInfoSub = this.subdivisionOptions$.subscribe((subdivisions) => {
      console.log('subdivisions', subdivisions); // Todo: remove: #may6
      this.subdivisionOptions = subdivisions?.states ?? []
      console.log('this.subdivisionOptions', this.subdivisionOptions); // Todo: remove: #may6
    })

    this.feeQuoteStateSub = this.feeQuoteState$.subscribe((feeQuoteData) => {
      console.log('feeQuoteData', feeQuoteData); // Todo: remove: #may6
      if (this.operation === 'withdraw') {
        this.exchangeRate = feeQuoteData?.transactions[0]?.payoutAmountDetails?.fxRate ?? '???'
      }
      else if (this.operation === 'deposit') {
        this.exchangeRate = feeQuoteData?.transactions[0]?.sendAmountDetails?.fxRate ?? '???'
      }
    })

    this.dpSendValidateSuccessSub = this.actions$.pipe(
      ofType(
        DpSendValidateSuccess
      )
    ).subscribe((action) => {
      console.log('SendValidate call (DP) complete', action.sendValidateResponse)

      const response = action.sendValidateResponse
      this._sendValResponseError$.next(response.errors!)
      const gffpErrors = (response.errors && response.errors.find((error: any) => error.category === GFFP_FIELDS_CATEGORY)?.offendingFields?.map((fieldObj: { field: any }) => 
          fieldObj.field
      )) || undefined!
      console.log('dpSendValidateSuccessSub gffpErrors', gffpErrors) // Todo: remove: #may6
      this._gffpFieldNames.next(gffpErrors)

      if (!response.readyForCommit && gffpErrors) {
        this.currentStep = this.steps['gffp']
      }
      else if (response.readyForCommit && (!response.errors || response.errors.length === 0)) {
        this.selectTransactionStateSub = this.store.select(selectTransactionState).subscribe((transactionData) => {
          console.log('transactionData', transactionData); // Todo: remove: #may6
          this.transactionData = transactionData
        })
        this._summaryData$.next(this.transactionData)
        this.currentStep = this.steps['summary']
      }
      else {
        console.log('SOMETHING went wrong during sendValidate') // Todo: remove: #may6
        // Todo: Tim: #may6 - need error handling 
      }
    })

    this.dpSendCommitSuccessSub = this.actions$.pipe(
      ofType(DpSendCommitSuccess)
    ).subscribe((action) => {
      console.log('dpSendCommitSuccessSub - DpSendCommitSuccess'); // Todo: remove: #may6
      this.currentStep = this.steps['confirmation']
    })

    this.enumerationsResponse$ = this.store.pipe(select(selectEnumFields))
    // Todo: Tim: #may6 - Possible new sendvalidate endpoint, may need new action
    const enumPayload = {
      userLanguage: 'en-US',
      targetAudience: 'CUSTOMER_FACING',
      countryCode: this.country,
      language: this.locale?.substring(0, 2)
    }
    console.log('dp enumPayload...', enumPayload) // TOdo: remove: #may6
    this.store.dispatch(DpGetEnums({ getEnumRequest: enumPayload, endpoint: this.endpointVersion, sendValidatePayload: this.sendValidatePayload, transactionId: this.transactionId, cmsLabels: this.cmsLabels}))
  }

  ngOnDestroy() {
    console.log('ngOnDestroy for digital-payment') // Todo: remove: #may6
    if (this.serviceOptionsStateSub) { this.serviceOptionsStateSub.unsubscribe() }
    if (this.queryParamsStateSub) { this.queryParamsStateSub.unsubscribe() }
    if (this.cmsLabelsStateSub) { this.cmsLabelsStateSub.unsubscribe() }
    if (this.countryDetailsSub) { this.countryDetailsSub.unsubscribe() }
    if (this.dpSendValidateSuccessSub) { this.dpSendValidateSuccessSub.unsubscribe() }
    if (this.stateInfoSub) { this.stateInfoSub.unsubscribe() }
    if (this.selectTransactionStateSub) { this.selectTransactionStateSub.unsubscribe() }
    if (this.feeQuoteStateSub) { this.feeQuoteStateSub.unsubscribe() }
  }

  // Todo: Tim: #may6 - review if back button is necessary
  public handleBackButton() {
    console.log('back button clicked...') // TOdo: remove:
    this.currentStep = this.currentStep > 0 ? this.currentStep - 1 : this.currentStep
  }

  // Todo: Tim: #may6 - review if back button is necessary
  public todoNext() {
    this.currentStep = this.currentStep < this.steps['confirmation'] ? this.currentStep + 1 : this.currentStep
  }
  
  // Todo: Tim: #may6 - review if back button is necessary
  public displayBackButton() {
    if (!!this.currentStep && this.currentStep > 0 && this.currentStep < this.steps['confirmation']) return true
    return false // Todo: Tim: #mar25
  }

  // Todo: Tim: Copy/paste from home.component.ts, needs refactoring
  public onGffpSubmit(data: any) { // Todo: Tim: fix type 
    console.log('onGffpSubmit is triggering...', data) // Todo: remove: #may6
    const familyNames = pick(['additionalFamilyNames'], data.sender)
    console.log("familyNames :", familyNames) // Todo: Remove: #may6
    const senderWithoutFamilyNames = omit(
      ['additionalFamilyNames'],
      data.sender
    )
    // this.error = ''
    let payload = { ...this.sendValidatePayload }
    let senderPayload = {}
    senderPayload = {
      ...this.sendValidatePayload.sender,
      ...senderWithoutFamilyNames,
    }

    if (
      !isEmpty(familyNames) &&
      pathOr('', ['additionalFamilyNames', 'mothersMaidenName'], familyNames)
    ) {
      const familyArray = [
        {
          lastName: pathOr(
            '',
            ['additionalFamilyNames', 'mothersMaidenName'],
            familyNames
          ),
          type: 'MOTHER_S_MAIDEN_NAME',
        },
      ]
      senderPayload['additionalFamilyNames'] = familyArray
    }

    payload.sender = { ...senderPayload }
    this.sendValidatePayload = {
      ...this.sendValidatePayload,
      sender: {
        ...this.sendValidatePayload.sender,
        ...senderPayload,
      },
    }
    
    if (
      senderWithoutFamilyNames.additionalTransactionDetails ||
      data.additionalTransactionDetails
    ) {
      this.sendValidatePayload = {
        ...this.sendValidatePayload,
        additionalTransactionDetails: {
          getRelationshipToReceiver: true,
          ...data.additionalTransactionDetails,
        },
      }
    }
    // this._analyticsBtnClickEvent('onGffpSubmitEvent', PageTitles.IDENTITY_PAGE)
    // this._summaryData$.next(undefined) // resetting summary data
    this.store.dispatch(
      DpSendValidate({
        transactionId: this.transactionId,
        sendValidatePayload: this.sendValidatePayload,
        endpoint: this.endpointVersion,
      })
    )
  }

  public onCommit(): void {
    console.log('DP - onCommit'); // Todo: remove: #may6
      // this._analyticsBtnClickEvent(
      //   'onSummarySubmitEvent',
      //   PageTitles.SUMMARY_PAGE
      // );
      // this.error = '';
      this.store.dispatch(
        DpSendCommit({
          transactionId: this.transactionId,
          locale: this.locale,
          endpoint: this.endpointVersion
        })
      )
      // this.showBackIcon = false;
      // // console.log(" this.stepper 01 : ",  this.stepper);
      // this.stepper.selectedIndex = this.steps['confirmation'];
      // // console.log(" this.stepper 02 : ",  this.stepper);
      // this._analyticsPageNavigation(
      //   'loadedConfirmationPage',
      //   PageTitles.CONFIRMATION_PAGE
      // );
    }

  public navigateToTransactionFlow(): void {
    this.router.navigate(['/'], { queryParamsHandling: 'preserve' })
  }
}
